import { render } from "./VueSample.vue?vue&type=template&id=6b7cdd32&scoped=true"
import script from "./VueSample.vue?vue&type=script&lang=js"
export * from "./VueSample.vue?vue&type=script&lang=js"

import "./VueSample.vue?vue&type=style&index=0&id=6b7cdd32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7cdd32"]])

export default __exports__